import { render, staticRenderFns } from "./PersonCheckDetail.vue?vue&type=template&id=27e48974&scoped=true"
import script from "./PersonCheckDetail.vue?vue&type=script&lang=js"
export * from "./PersonCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e48974",
  null
  
)

export default component.exports